import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { VbPageHeaderComponent } from './VbPageHeader.Component';

@NgModule({
	imports: [
		CommonModule
	],
	declarations: [
		VbPageHeaderComponent
	],
	exports: [
		VbPageHeaderComponent
	]
})
export class VbPageHeaderModule { }
